import { observer } from 'mobx-react-lite';
import * as React from 'react';
import itemDeleteModalStore from 'owa-calendar-modal-store/lib/store/store';
import { ItemDeleteModalContent } from 'owa-calendar-modal-view';
import { lazyHideItemDeleteModal } from 'owa-calendar-modal-actions';
import { Modal } from '@fluentui/react/lib/Modal';

import styles from './ItemDeleteModalRenderer.scss';

/**
 * Component for rendering item delete modal
 */
export default observer(function ItemDeleteModalRenderer(props: any) {
    if (itemDeleteModalStore.deleteModalViewState) {
        return (
            <Modal
                isOpen={itemDeleteModalStore.deleteModalViewState != null}
                onDismiss={onCalloutDismiss}
                isBlocking={false}
                forceFocusInsideTrap={true}
                containerClassName={styles.dialog}>
                <ItemDeleteModalContent itemId={itemDeleteModalStore.deleteModalViewState.itemId} />
            </Modal>
        );
    } else {
        return null;
    }
});

function onCalloutDismiss() {
    lazyHideItemDeleteModal.importAndExecute();
}
